<template>
  <div ref="tableBox">
    <el-table :data="tableData">
      <el-table-column type="index" width="20px" label="#"></el-table-column>
      <el-table-column property="occurredDate" width="110px" label="事发时间"
                       :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="description" label="事件描述" min-width="200px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventLevel" width="80px" label="事件等级" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventType" width="120px" label="事件类型" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventReason" width="80px" label="事件原因" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="eventPhase" width="80px" label="事发阶段" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="company" width="80px" label="航空公司" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="reasonAnalysis" label="原因分析" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="deathToll" align="center" width="80px" label="死亡人数" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="updateTime" width="110px" label="更新时间" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="operateUser" width="80px" label="操作人" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <div class="page-wrapper">
      <el-pagination background layout="prev, pager, next" :total="page.total" :current-page.sync="page.num"
                     :page-size.sync="page.size">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";

export default {
  props: {
    year: Number,
    month: Number,
  },
  data() {
    return {
      //表格数据
      tableData: [],
      //分页
      page: {
        num: 1,
        size: 5,
        total: null,
      },
    }
  },
  mounted() {
    this.buildData();
  },
  methods: {
    /**
     * 构建表格数据
     */
    buildData() {
      getRequest(`/result/accident/detail/${this.year}`, {
        month: this.month,
        pageNum: this.page.num,
        pageSize: this.page.size
      }, this.$refs.tableBox).then(res => {
        this.tableData = res.data.records
        this.page.total = res.data.total
      })
    },
    initPage() {
      this.page.num = 1;
    },
  },
  watch: {
    year() {
      this.buildData();
    },
    month() {
      this.buildData();
    },
    "page.num"() {
      this.buildData();
    }
  }
}
</script>

<style scoped lang="less">
.page-wrapper {
  text-align: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/result/AccidentDetail.vue